import httpClient from './apiService';
import { Get_Token } from 'resolvers/Get_Token';

export async function getBusinesses() {
    const response = await httpClient.get('/super-admin/businesses', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function getCustomers() {
    const response = await httpClient.get('/super-admin/customers', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function approve(idBusiness, body) {
    const response = await httpClient.patch(`/super-admin/businesses/${idBusiness}/approve`, body, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function reject(idBusiness) {
    const response = await httpClient.patch(
        `/super-admin/businesses/${idBusiness}/reject`,
        {},
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
}

export async function deactivate(idBusiness) {
    const response = await httpClient.patch(
        `/super-admin/businesses/${idBusiness}/deactivate`,
        {},
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
}

export async function freeze(idBusiness) {
    const response = await httpClient.patch(
        `/super-admin/businesses/${idBusiness}/freeze`,
        {},
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
}

export async function unfreeze(idBusiness) {
    const response = await httpClient.patch(
        `/super-admin/businesses/${idBusiness}/unfreeze`,
        {},
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
}

export async function reactivate(idBusiness) {
    const response = await httpClient.patch(
        `/super-admin/businesses/${idBusiness}/reactivate`,
        {},
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
}

export async function getCardCategories(idBusiness) {
    const response = await httpClient.get(`/businesses/${idBusiness}/card-categories`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function createCardCategories(idBusiness, data) {
    const response = await httpClient.put(
        `/businesses/${idBusiness}/card-categories`,
        { categoryName: data },
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
}

export async function updateSpendLimit(idBusiness, body) {
    const response = await httpClient.patch(`/super-admin/businesses/${idBusiness}/credit-limit`, body, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function getTransactions({ page = 0, limit = 10, ...rest }) {
    const response = await httpClient.get(`/businesses/transactions`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        },
        params: {
            page,
            limit,
            ...rest
        }
    });
    return response.data;
}

export async function getTransactionsCategories(idBusiness) {
    const response = await httpClient.get(`/businesses/${idBusiness}/transaction-categories`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function createTransactionsCategories(idBusiness, data) {
    const response = await httpClient.post(
        `/businesses/${idBusiness}/transaction-categories`,
        { categoryName: data },
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
}

export async function deleteCardTransactionCategory(idBusiness, idCategory) {
    const response = await httpClient.delete(`/businesses/${idBusiness}/transaction-categories/${idCategory}`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function getNumberCardTransactionWithCategory(idBusiness, idCategory) {
    const response = await httpClient.get(`/businesses/${idBusiness}/transaction-categories/${idCategory}/total`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function downloadTransactionReconciliationZip(idBusiness, queryParams) {
    const response = await httpClient.get(`/businesses/${idBusiness}/transactions/download-zip`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        },
        params: queryParams,
        responseType: 'blob'
    });
    return response;
}
